import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { FormBuilder, Validators, FormArray, UntypedFormControl } from '@angular/forms';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { NgxDropzoneChangeEvent,NgxDropzonePreviewComponent } from 'ngx-dropzone';
import { SystemService } from '../../../services/system.service';
import { AngularEditorConfig } from '@kolkov/angular-editor';

@Component({
  selector: 'app-modules',
  templateUrl: './modules.component.html',
  styleUrls: ['./modules.component.scss']
})
export class ModulesComponent {
	modules: any = false;
	mod = {};
	@ViewChild('moduleEdit') moduleEditRef: ElementRef;
	descCtrl = new UntypedFormControl('');
	moduleForm: any;
	constructor(
		private formBuilder: FormBuilder,
		public systemService: SystemService,
		private modalService: NgbModal
	) {}
	editorConfig: AngularEditorConfig = {
		editable: true,
		spellcheck: true,
		height: '300',
		minHeight: '300',
		maxHeight: '300',
		width: 'auto',
		minWidth: '0',
		translate: 'yes',
		enableToolbar: true,
		showToolbar: true,
		defaultParagraphSeparator: '',
		defaultFontName: '',
		defaultFontSize: '',
		fonts: [
			{ class: 'arial', name: 'Arial' },
			{ class: 'times-new-roman', name: 'Times New Roman' },
			{ class: 'calibri', name: 'Calibri' },
			//{ class: 'comic-sans-ms', name: 'Comic Sans MS' }
		],
		customClasses: [{
			name: 'quote',
			class: 'quote',
		},
		{
			name: 'Title',
			class: 'titleText',
			tag: 'h2',
		},
		],
		sanitize: false,
		toolbarPosition: 'top',
		toolbarHiddenButtons: [
			[],
			['fontSize']
		]
	};

	ngOnInit(): void {
		this.moduleForm = this.formBuilder.group({
			module_id: [''],
			name: [''],
			code: '',
			setting: '',
		});
		this.descCtrl.setValue('');
		this.loadModules();
	}



	loadModules() {
		const data = [];
		this.systemService.getModules(data).subscribe(r => {
			this.modules = r;
		});
	}
	
	updateForm(control, event) {
		this.moduleForm.get('description').setValue(event);
		this.descCtrl.setValue(event);
	}
	
	editModule(mod: any) {
		this.mod = mod;
		this.moduleForm = this.formBuilder.group({
			module_id: [mod.module_id],
			name: [mod.name],
			heading: [mod.heading],
			description: [mod.edit, Validators.required],
			status: [mod.status],
		});
		this.descCtrl.setValue(mod.edit);

		this.modalService.open(this.moduleEditRef, { ariaLabelledBy: 'modal-title', size: 'xl' }).result.then((result) => {
			// Handle modal close
		}, (reason) => {
			// Handle modal dismiss
		});
	}

	addModule() {
		this.moduleForm = this.formBuilder.group({
			module_id: [''],
			name: [''],
			code: '',
			setting: '',
		});
		this.descCtrl.setValue('');
		this.modalService.open(this.moduleEditRef, { ariaLabelledBy: 'modal-title', size: 'xl' }).result.then((result) => {
			// Handle modal close
		}, (reason) => {
			// Handle modal dismiss
		});
	}

	removeModule(mod: any) {
		const data = { module_id: mod.module_id };
		this.systemService.removeModule(data).subscribe(() => {
			// Force reload from server to get fresh data with updated cache busters
			this.loadModules();
		});
	}

	saveModule() {
		const data = this.moduleForm.value;
		this.systemService.saveModule(data).subscribe(() => {
			this.modalService.dismissAll();
			this.loadModules();
		});
	}

}
